import { CONFIG } from '@/core/config';

export function generateMhsDocumentUrl(id: string): string {
  return `${CONFIG.APPS_BASE_URL}/admin/study/${id}/medical-history/radiologist/embed`;
}

export function generateRadiologyReportDocumentUrl(id: string): string {
  return `${CONFIG.HI_SERVER}/radiologist/study/${id}/latest-pdf-report?viewOnly=True`;
}
